import React from 'react'
import PropTypes from 'prop-types'

// Shows or hides a region. The label is the caller's; `aria-expanded`/`aria-controls` are not,
// which is the point of sharing it. `row` dresses it as a full-width strip with a chevron.
const DisclosureButton = ({ controls, expanded, onToggle, children, row }) => (
  <button
    type="button"
    className={`gl-event-setup-disclosure${row ? ' gl-event-setup-disclosure--row' : ''}`}
    aria-expanded={expanded}
    aria-controls={controls}
    onClick={onToggle}
    >
    {children}
  </button>
)

DisclosureButton.propTypes = {
  controls: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  row: PropTypes.bool,
}

export default DisclosureButton
